<template>
  <base-dialog-form
    ref="iscrittiEventoDialog"
    :title="$t('event_subscriber')"
    color="secondary"
    icon="mdi-account-group"
  >
    <v-container>
      <list-ordini :card="false" mode="evento" :idEvento="idEvento"></list-ordini>
    </v-container>
  </base-dialog-form>
</template>
 
<script>
import DataTables from "@/components/base/DataTables.vue";
import listOrdini from "@/widget/listOrdini.vue";

export default {
  name: "iscritti-evento",
  components: {
    DataTables,
    listOrdini
  },
  data() {
    return {
      idEvento: null
    };
  },
  methods: {
    open(idEvento) {
      this.idEvento = idEvento;
      this.$refs.iscrittiEventoDialog.open();
    }
  }
};
</script>